import { Accordion, AccordionButton, AccordionItem, AccordionPanel, Box, Button, Container, Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, Flex, Heading, IconButton, Image, Input, Link, Stack, Text, useDisclosure, useToast } from '@chakra-ui/react';
import Logo from './assets/img/logo.svg';
import { AddIcon, CloseIcon, HamburgerIcon, Search2Icon } from '@chakra-ui/icons';
import Image1 from './assets/img/img-1.png';
import Image2 from './assets/img/img-2.png';
import Image3 from './assets/img/img-3.png';
import Line from './assets/img/line.svg';
import { useState } from 'react';
import axios from 'axios';


function App() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [email, setEmail] = useState('')
  const [isLoading, setLoading] = useState('')
  const toast = useToast()
  const features = [
    {
      "icon": "",
      "color": "#6C47FF",
      "title": "Tailored Attendee Profiling",
      "subtitle": "Instantly gather comprehensive details about an attendee and their company, ensuring you have all the information at your fingertips."
    },
    {
      "icon": "",
      "color": "#F34971",
      "title": "Real-time News Alerts",
      "subtitle": "Stay updated with the latest developments or news about the company or their industry, ensuring your conversations are timely and relevant."
    },
    {
      "icon": "",
      "color": "#39C0C8",
      "title": "Pre-Meeting Analysis",
      "subtitle": "Analyze past engagements with similar prospects to strategically tailor your approach for the upcoming meeting."
    },
    {
      "icon": "",
      "color": "#FDB52A",
      "title": "Easy collaboration",
      "subtitle": "Collaborate with your team in real-time, jotting down observations, questions, or strategies for the upcoming meeting."
    }
  ]
  const faqs = [
    {
      "title": "What is AttendeesAI",
      "subtitle": "Attendees AI is a pre-meeting research platform designed to equip salespeople with tailored insights for their upcoming prospect meetings."
    },
    {
      "title": "How does AttendeesAI gather information about prospects?"
    }
  ]
  const menus = [
    {
      "title": "About us",
      "url": "/"
    },
    {
      "title": "Product",
      "url": "/"
    },
    {
      "title": "Resources",
      "url": "/"
    }
  ]

  const submitWaitlist = async () => {
    try {
      setLoading(true);
      const request = await axios.post(
        'https://dev.api.fanbaseai.com/auth/attendeesai/waitlist/',
        {
          email
        }
      )
      const { status } = request.data;
      if (status === 200) {
        toast({
          title: "You are on our waitlist",
          status: "success",
          description: "We'll let you know when are ready to launch",
        })
      } else {
        const error = new Error("Something went wrong");
        throw error
      }
    } catch (e) {
      toast({
        title: e.message,
        status: "error",
        description: "Please try again later",
      })
    } finally {
      setLoading(false)
    }
    
  }


  return (
    <Box>
      <Flex alignItems={"center"} borderBottom={"1px solid #EAEAEA"} py={3} px={[4, 4, 10]} justifyContent={"space-between"}>
        {/* Mobile Navigation */}
          <Drawer onClose={onClose} isOpen={isOpen}>
          <DrawerOverlay />
          <DrawerContent maxW={'240px'}>
            <DrawerCloseButton />
            <Stack fontSize={"sm"} gap={4} p={4} fontWeight={"semibold"}>
              {menus.map(m => <Link href={m.url} >{m.title}</Link>)}
              <Flex gap={2} mt={2} justifyContent={"space-between"}>
              <Button _hover={{
                  backgroundColor: "black"
                }} backgroundColor={"black"} color={"white"} rounded={0} p={4}>Join the waitlist</Button>
              <Button colorScheme={"primary"} rounded={0}>Login</Button>
              </Flex>
            </Stack>
            </DrawerContent>
          </Drawer>
          <Box display={[null, null, "none"]}>
            <IconButton onClick={onOpen} size={"sm"} variant={"outline"} icon={<HamburgerIcon />} />
          </Box>
        {/* Mobile Naviation End */}
        <Box>
          <Image height={6} src={Logo} />
        </Box>
        {/* Desktop Navigation */}
        <Flex display={["none", "none", "flex"]} alignItems={"center"} fontWeight={"semibold"} gap={10}>
          {menus.map(m => <Link href={m.url} >{m.title}</Link>)}
          <Button colorScheme={"primary"} rounded={0}>Login</Button>
        </Flex>
        <Button display={[null, null, "none"]} size={"sm"} colorScheme={"primary"} rounded={0}>Login</Button>
      </Flex>
      <Container size={"container.xl"} maxW={"container.xl"}>
        <Flex gap={[6, 6, 0]} direction={["column", "column", "row"]} w={"full"} h={['auto', 'auto', '80vh']} alignItems={"center"} justifyContent={"space-between"}>
          <Stack pt={[14, 14, 0]} gap={6} flex={0.4}>
            <Heading variant={"h1"} size={"2xl"}>Boost your <span style={{
              backgroundImage: "url('/img/circle.svg')",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center"
            }}>sales</span> team with <Text as={"span"} color='#8B4CED'>pre-meeting</Text> research</Heading>
            <Text fontWeight={"semibold"}>AttendeesAI is a pre-meeting research platform designed to equip sales people with tailored insights for their upcoming prospect meetings.</Text>
            <Flex direction={["column", "column", "row"]} w={["full", "full",0.9]} gap={3}>
                <Input value={email} onChange={(e) => {
                  setEmail(e.target.value)
                }} fontWeight={"semibold"} placeholder="Enter your email address" rounded={0} />
                <Button onClick={() => {
                  submitWaitlist()
                }} disabled={isLoading} isLoading={isLoading} w={["full", "full", "180px"]} boxShadow={"6px 6px 0px 0px #8B4CED"} _hover={{
                  backgroundColor: "black",
                  boxShadow: "none"
                }} backgroundColor={"black"} color={"white"} rounded={0} p={4}>Join the waitlist</Button>
            </Flex>
          </Stack>
          <Box flex={0.5}>
            <Image src={Image1} />
          </Box>
        </Flex>
        <Flex gap={[8, 8, 4]} mt={[16, 16, 16]} direction={["column", "column", "row"]} alignItems={"center"} justifyContent={"space-around"}>
          <Box flex={0.5}>
            <Image src={Image2} />
          </Box>
          <Stack flex={0.45} gap={9}>
            {features.map(f => {
              return (
                <Flex gap={5}>
                  <Box>
                    <IconButton _hover={{ backgroundColor: f.color, boxShadow: "none" }} backgroundColor={f.color} color={"white"} boxShadow={'0px 4px 0px 0px black'} rounded={"full"} height={"fit-content"} p={4} size={"lg"} icon={<Search2Icon />} />
                  </Box>
                  <Stack>
                    <Heading as='h2' size='lg'>{f.title}</Heading>
                    <Text fontWeight={"semibold"}>{f.subtitle}</Text>
                  </Stack>
                </Flex>
              )
            })}
          </Stack>
        </Flex>
        <Flex direction={["column-reverse", "column-reverse", "row"]} gap={10} py={[24, 24, 36]} alignItems={"center"} justifyContent={"center"}>
            <Stack gap={2} flex={0.3} textAlign={"center"} alignItems={"center"}>
                <Text textTransform={"uppercase"} fontWeight={"bold"}>SOME BLAZING TEXT</Text>
                <Heading variant={"h2"} fontWeight={"bold"} size={"xl"}>Synced with tools you love</Heading>
                <Image mt={-2} mb={-4} src={Line} /> 
                <Text fontWeight={"semibold"}>Seamlessly sync your meetings and pull relevant data from platforms like Salesforce, HubSpot, and more for enriched insights.</Text>
                <Flex mt={4} gap={6}>
                  <Button h={"54px"} w={"140px"} boxShadow={"6px 6px 0px 0px black"} _hover={{
                  backgroundColor: "black",
                  boxShadow: "none"
                }} backgroundColor={"#8B4CED"} color={"white"} rounded={0}>Join the waitlist</Button>
                  <Button color={"black"} h={"54px"} w={"140px"} variant={"outline"} colorScheme="blackAlpha" rounded={0}>Talk to sales</Button>
                </Flex>
            </Stack>
            <Box flex={0.5}>
            <Image src={Image3} /></Box>
        </Flex>
        <Stack alignItems={"center"}>
          <Heading textAlign={"center"} variant={"h3"} size={"lg"}>Frequently Asked Questions</Heading>
          <Text textAlign={"center"} mt={4} fontWeight={"semibold"}>Got Questions? We've got the answers before you even ask.</Text>
          <Accordion mt={8} w={['100%', '100%', '60%']} defaultIndex={[0]}>
            {faqs.map(f => <AccordionItem mb={5} rounded={10} border={"1px solid #EAEAEA"} py={6} px={[6, 16]} userSelect={"none"}>
            {({ isExpanded }) => (
              <Flex>
                <IconButton color={isExpanded ? "white" : "#8B4CED"} icon={isExpanded ? <CloseIcon /> : <AddIcon />} backgroundColor={isExpanded ? "#8B4CED" : "#EEE3FF"} rounded={"full"}/>
                <Stack cursor={"pointer"} flex={1}>
                  <AccordionButton outline={"none"} boxShadow={"none !important"} py={0} _hover={{ backgroundColor: "none" }}>
                    <Heading textAlign={"left"} variant={"h2"} size={"md"}>
                      {f.title}
                    </Heading>
                  </AccordionButton>
                  <AccordionPanel fontWeight={"semibold"} pb={4}>
                  {f.subtitle}
                </AccordionPanel>
                </Stack>
              </Flex>)}
            </AccordionItem>)}
          </Accordion>
        </Stack>
      </Container>
      <Stack mt={16} borderTop={"1px solid #CACACA"} p={[6, 6, 16]}>
        <Flex gap={[10, 10, 0]} direction={["column", "column", "row"]}  justifyContent={"space-between"}>
          <Stack gap={6}>
            <Box>
            <Image height={6} src={Logo} />
            </Box>
            <Flex direction={["column", "column", "row"]} fontSize={"sm"} fontWeight={"semibold"} gap={[4, 4, 6]}>
              <Text>Product</Text>
              <Text>About us</Text>
              <Text>Resources</Text>
              <Text>Careers</Text>
              <Text>Testimonials</Text>
            </Flex>
          </Stack>
          <Stack>
            <Text fontWeight={"bold"}>Subscribe for updates</Text>
            <Flex gap={3}>
                <Input fontSize={"sm"} fontWeight={"semibold"} _placeholder={{ color: '#505050' }} placeholder="Enter your email" rounded={0} />
                <Button h={"80%"} size={"sm"} w={"140px"} boxShadow={"4px 4px 0px 0px #8B4CED"} _hover={{
                  backgroundColor: "black",
                  boxShadow: "none"
                }} backgroundColor={"black"} color={"white"} rounded={0} p={4}>Subscribe</Button>
            </Flex>
            <Text fontSize={"xs"}>By subscribing you agree to with our <Text as={"span"} fontWeight={"semibold"} style={{ textDecoration: "underline", fontWeight: "semibold" }}>Privacy Policy</Text></Text>
          </Stack>
        </Flex>
        <Flex gap={[6, 6, 0]} direction={["column", "column", "row"]}  alignItems={"center"} pt={8} mt={8} borderTop={"0.5px solid black"} justifyContent={"space-between"}>
            <Flex fontWeight={"semibold"} fontSize={"xs"} textDecor={"underline"} alignItems={"center"} gap={6}>
              <Link>Privacy Policy</Link>
              <Link>Terms of Service</Link>
              <Link>Cookies Settings</Link>
            </Flex>
            <Text fontSize={"sm"} fontWeight={"semibold"}>© 2023 Attendees AI. All rights reserved.</Text>
        </Flex>
      </Stack>
    </Box>
  );
}

export default App;
